import React from "react";
import { connect } from "react-redux";

import { portraits } from "../../../assets/images/races";
import { openContentPopup, toggleMenu } from "../../../store/actions";

const GovernorateInfo = props => (
  <div className="player fixed-menu">
    <a
      className={`notification visible-xs`}
      style={{ paddingLeft: "4px", marginBottom: "3px" }}
      onClick={props.toggleMenu}
    >
      <i className="icon icon-xmd icon-hamburger"/>
    </a>
    <div className="race-avatar">
      <img src={portraits[props.race.name]} alt=""/>
    </div>
    <div className="player-content">
      <h3 className="player-name">
        <a
          className="white link"
          onClick={() => props.openContentPopup({
            name: "OwnGovernorateProfile",
            title: props.name,
            icon: "popularita"
          })}
        >
          {props.name}
        </a>
      </h3>
      <p>
        <span className="player-alliance">
          {props.alliance ? <a
            className="white link"
            onClick={() => props.openContentPopup({
              name: "OwnAllianceProfile",
              title: props.alliance.name,
              icon: null,
              owner: true
            })}
          >
            {props.alliance.name}
          </a> : <>non-alliance</>
          }
        </span>
      </p>
       <a onClick={props.toggleMenu} className="menu-toggle open link hidden-xs">
        <i className={`chevron ${props.showMenu ? "chevron-up" : "chevron-down"}`}/>
       </a>
    </div>
  </div>
);

const mapStateToProps = state => ({
  alliance: state.governorate.alliance,
  name: state.governorate.name,
  race: state.governorate.race,
  showMenu: state.ui.showMenu
});

const mapDispatchToProps = dispatch => ({
  toggleMenu: () => dispatch(toggleMenu()),
  openContentPopup: contentPopupOptions => dispatch(openContentPopup(contentPopupOptions))
});

export default connect(mapStateToProps, mapDispatchToProps)(GovernorateInfo);
